import { resolveApiUrl } from "~/utils/url/urlResolver";
import { type NotificationData } from "~/features/notifications/Messages";

export async function fetchLatestNotifications(): Promise<{
  results: NotificationData[];
  totalAmount: number;
}> {
  const url = resolveApiUrl("/notifications/last-notifications");
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const results: NotificationData[] = await response.json();

  return {
    results,
    totalAmount: 0,
  };
}
